module.exports = __webpack_public_path__ + "media/common/images/cta/san-4b487988754581280766723d7c3d2ae2.jpeg";